import styled from 'styled-components'
import { rgba } from 'polished'
import Link from './Link'
import Chevron from './icons/Chevron'

function PrevNextButtons( {
  nextHref = null,
  nextText = <>Next</>,
  prevHref = null,
  prevText = <>Previous</>,
} ) {
  return (
    <StyledPrevNextButtons>
      <Button
        href={ prevHref }
        text={ prevText }
      >
        <Chevron left />
      </Button>
      <Button
        href={ nextHref }
        text={ nextText }
      >
        <Chevron right />
      </Button>
    </StyledPrevNextButtons>
  )
}

function Button( { href, text, children } ) {
  return (
    <StyledButton $disabled={ !href }>
      { href && (
        <Link href={ href }>
          <i>{ text }</i>
          { children }
        </Link>
      ) }
      { !href && (
        <span>
          <i>{ text }</i>
          { children }
        </span>
      ) }
    </StyledButton>
  )
}

export const StyledPrevNextButtons = styled.div`
  display: flex;
  margin: -4px;
`

const StyledButton = styled.div<{ $disabled: boolean }>`
  box-sizing: border-box;
  flex: 0 0 50%;
  padding: 4px;

  a,
  span {
    display: flex;
    ${ p => p.theme.typo.switzer }
    font-size: ${ p => p.theme.typo.sizes.dropped };
    border: 1px solid ${ p => p.theme.colors.black };
    border-radius: 100px;
    white-space: nowrap;

    i,
    div {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0.7rem 0.7rem;
    }

    i {
      flex-grow: 1;
      font-style: normal;
    }
  }

  a {
    text-decoration: none;
    color: inherit;
    transition: background .3s ease-out;

    &:hover {
      background: ${ p => rgba( p.theme.colors.black, 0.1 ) };
    }
  }

  span {
    opacity: 0.6;
  }

  &:first-child {
    a,
    span {
      flex-direction: row-reverse;

      i {
        padding-right: 1.1rem;
        border-left: 1px solid ${ p => p.theme.colors.black };
      }

      div {
        padding-left: 0.9rem;
      }
    }
  }
  
  &:last-child {
    a,
    span {
      i {
        padding-left: 1.1rem;
      }

      div {
        padding-right: 0.9rem;
        border-left: 1px solid ${ p => p.theme.colors.black };
      }
    }
  }

  @media ( max-width: 350px ) {
    a,
    span {
      font-size: ${ p => p.theme.typo.sizes.tiny };

      i,
      div {
        padding: 0.5rem 0.5rem;
      }
    }
  }
`

export default PrevNextButtons
